import React from "react";
import NetworkLocations from "src/elements/networkConfig/Next";
function NetworkLocation(){ return <NetworkLocations/> } export default NetworkLocation;